/* eslint-disable no-underscore-dangle, no-useless-escape */
export const nodeEnv = process.env.NODE_ENV
export const isDev = nodeEnv === 'development'
export const isProd = nodeEnv === 'production'

/*
Use `REACT_APP_DEPLOY_ENV` custom environment variable to build for the different environments:

- `dev`: the default, uses the development endpoints
- `qa`: quality assurance endpoints
- `production`: production endpoints
- `new`: this is a special environment used during the data migration correction phase

*/

const DEPLOY_ENV = {
  qa: 'qa',
  production: 'production',
  dev: 'dev',
  new: 'new',
};

export const deployEnv = process.env.REACT_APP_DEPLOY_ENV
export const isDeployDev = isProd && deployEnv === DEPLOY_ENV.dev
export const isDeployQa = isProd && deployEnv === DEPLOY_ENV.qa
export const isDeployProduction = isProd && deployEnv === DEPLOY_ENV.production
export const isDeployNew = isProd && deployEnv === DEPLOY_ENV.new

const computedDeployUrl = ({
  qa, dev, production, __new__
}) => {
  const ENV = nodeEnv;
  // defaults to dev env
  if (ENV === 'production') {
    if (isDeployQa) return qa;
    if (isDeployProduction) return production;
    if (isDeployNew) return __new__;
  }
  return dev;
};

export const PORTAL_IMAGES_ENDPOINT = (() => {
  const qa = 'https://api-assets.qa.ua.pt/v1';
  const dev = 'https://api-assets.dev.ua.pt/v1';
  const production = 'https://api-assets.ua.pt/v1';

  return computedDeployUrl({
    qa,
    dev,
    production,
    __new__: production,
  });
})();

export const PORTAL_WWW = (() => {
  const qa = 'https://www.qa.ua.pt';
  const dev = 'https://www.dev.ua.pt';
  const production = 'https://www.ua.pt';
  const __new__ = 'https://www-new.ua.pt'

  return computedDeployUrl({
    qa,
    dev,
    production,
    __new__
  });
})();

export const PORTAL_API = (() => {
  const qa = 'https://api-portal.qa.ua.pt/api/v1';
  const dev = 'https://api-portal.dev.ua.pt/api/v1';
  const production = 'https://api-portal.ua.pt/api/v1';
  const __new__ = 'https://api-portal-new.ua.pt/api/v1';

  return computedDeployUrl({
    qa,
    dev,
    production,
    __new__,
  });
})();

export const PORTAL_HOST = (() => {
  const qa = 'www.qa.ua.pt';
  const dev = 'www.dev.ua.pt';
  const production = 'www.ua.pt';
  const __new__ = 'www.new.ua.pt'

  return computedDeployUrl({
    qa,
    dev,
    production,
    __new__,
  });
})();

// other
export const dateFormat = 'dd/MM/yyyy HH:mm:ss'
export const rootSubwebs = ['ua', 'aboutua', 'education', 'live', 'investigation', 'international', 'cooperate']
export const rootSubwebsHomeSlug = {
  ua: '',
  aboutua: 'universidade',
  education: 'estudar',
  live: 'viver',
  investigation: 'investigacao',
  international: 'internacional',
  cooperate: 'cooperacao'
}
export const slugRegex = /^(?!.*news).(?!.*noticias).[A-Za-z0-9]+(?:-[A-Za-z0-9]+)*$/
export const linkRegex = /^(?:https?:\/\/(?:[\w-]*\.)+\w+(?::\d+)?(?:\/\S*)?|\/(?:(?:pt|en)\/\S*)?|mailto:[_\w\.-]+@[\w\.]+)$/
export const linkRegexOptional = /^(?:https?:\/\/(?:[\w-]*\.)+\w+(?::\d+)?(?:\/\S*)?|\/(?:(?:pt|en)\/\S*)?|mailto:[_\w\.-]+@[\w\.]+)?$/
export const phoneRegex = /^(?!\/)(?!.*\/$)[0-9\s()+/-]+$/
export const linkVideoRegex = /^(https?:\/\/)?(www\.)?(youtube\.com\/(watch\?v=|playlist\?list=)[\w\-]+(&[\w\-]+=[\w\-]+)*|youtu\.be\/[\w\-]+|vimeo\.com\/\d+|videocast\.fccn\.pt\/.+)$/
export const defaultSeoImage = 'https://static.ua.pt/images/ua/sm-campus.png'
export const defaultHtmlTable = `<table border="0" style="width:100%">
<thead>
<tr>
<th>Header A</th>
<th>Header B</th>
</tr>
</thead>
<tbody>
<tr>
<td>C&eacute;lula A</td>
<td>C&eacute;lula B</td>
</tr>
</tbody>
</table>`
